import React, { useState } from 'react';
import styles from '../css/bg.module.css';
import {
    Typography,
    IconButton,
    Card,
    CardContent,
    Button,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCart } from '../actions/cartActions';
import CartItem from '../components/CartItem';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import NavBar from './NavBar';
import { getTotalPrice } from '../selectors';
import { Link } from 'react-router-dom';

const Cart = (props) => {
    const user = useSelector((state) => state.user);
    const cart = useSelector((state) => state.cart);
    const totalPrice = useSelector((state) => getTotalPrice(state));
    return (
        <div>
            <NavBar match={props.match} />
            <div style={{ padding: '2rem', maxWidth: '500px', margin: 'auto' }}>
                <Typography variant="h1">Cart</Typography>
                <div
                    style={{
                        marginBottom: '2rem',
                        marginTop: '.5rem',
                    }}
                >
                    <p style={{ fontSize: '1.2rem', marginBottom: 0 }}>
                        Welcome,{' '}
                        <Link to="/profile" style={{ color: 'var(--grey)' }}>
                            {user.displayName || 'guest user'}
                        </Link>
                    </p>
                </div>
                {!cart.length && <p>There are no items in your cart. </p>}
                {cart.map((item) => (
                    <CartItem
                        key={item.sku}
                        sku={item.sku}
                        amount={item.amount}
                    />
                ))}
                {!!cart.length && (
                    <>
                        <Card
                            style={{
                                marginBottom: '2rem',
                                boxShadow: 'none',
                                borderRadius: '1rem',
                                width: '100%',
                            }}
                        >
                            <CardContent
                                style={{
                                    padding: '1rem',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Typography variant="h6">Total: </Typography>
                                <Typography
                                    style={{
                                        fontWeight: '700',
                                        fontSize: '1.1rem',
                                    }}
                                >
                                    ${totalPrice.toFixed(2)}
                                </Typography>
                            </CardContent>
                        </Card>
                        <Button variant="contained">Checkout</Button>
                    </>
                )}
            </div>
        </div>
    );
};

export default Cart;
